<script>
  import { ignore } from "../../Common/tools";

  import StickyNote from "../Components/StickyNote.svelte";
  import {External, M} from "../../external";

  export let data,
    onChange = ignore;

  let cmps = [];
  let counter = 0;

  let newNote;

  export function get() {
    return data;
  }

  const onAdd = () => {
    newNote = newNote.trim();
    if (!newNote) return;
    counter = 0;
    if (data && data.length) {
      counter =
        Math.max.apply(
          Math,
          data.map(function (note) {
            return note.id;
          })
        ) + 1;
    }

    data = [
      {
        id: counter,
        message: newNote,
        active: false,
        fullname: External.userName,
        modified: Date.now()
      },
      ...data
    ];
    newNote = "";
    onChange();
  };

  const onPin = (index) => {
    let counter = 0;
    for (let counter = 0; counter < data.length; counter++) {
      if (counter === index) {
        data[counter].active = data[counter].active ? false : true;
      } else {
        data[counter].active = false;
      }
    }
    onChange();
  };

  let editable = -1;
  const onEdit = (index) => {
    if (editable != index) {
      editable = index;
    } else {
      editable = -1;
    }
  };

  const onRemove = (index) => {
    External.Tools.prompt(M.DELETE, M.NOTE_DELETE_QST, function () {
      data = [...data.slice(0, index), ...data.slice(index + 1, data.length)];
      onChange();
    });
  };

  const onKeyPress = (e) => {
    if (e.charCode === 13) onAdd();
  };
  $: cmps = cmps.filter((el) => el);
</script>

<div class="col20 f-left small-rules mb-25">
  <div class="automation-comment-input flex align-center">
    <div class="flex-1 mr-10">
      <input
        type="text"
        name="note"
        bind:value={newNote}
        on:keypress={onKeyPress}
        placeholder="{M.ADD_NEW_COMMENT}"
        class="focus transition-border rounded-effect"
      />
    </div>
    <a on:click={() => onAdd()} class="comment-send-btn blue rounded-effect"
      ><span class="material-icons-outlined"> reply </span></a
    >
  </div>

  <ul>
    {#each data as note, index (note.id)}
      <StickyNote
        bind:this={cmps[index]}
        editable={editable === index}
        bind:data={note}
        onEdit={() => onEdit(index)}
        onPin={() => onPin(index)}
        onRemove={() => onRemove(index)}
      />
    {/each}
  </ul>
</div>
